import { NON_BR_SPACE } from '@/components/strings';

export const product = {
  power7: 'power-7',
  power1: 'power-1',
  powerPlus: 'power-plus',
  originalPlus: 'original-plus',
  original: 'original',
  deluxe7: 'deluxe-7',
} as const;

export type ProductKeys = (typeof product)[keyof typeof product];

export const productCategories = {
  eBike: 'eBike',
  city: 'city',
  other: 'other',
} as const;

type ProductCategory =
  (typeof productCategories)[keyof typeof productCategories];

export interface ProductConfig {
  assetCategoryId: string;
  assetCategoryCode: string;
  assetCategoryName: string;
  id: ProductKeys;
  translationKey: keyof typeof product;
  image: string;
  imageConfigure: string;
  imageRecommended: string;
  imageBasket?: string;
  imageBasketMini?: string;
  name: string;
  uiName: string;
  productCategory: ProductCategory;
}

export const productsConfig: Record<ProductKeys, ProductConfig> = {
  [product.power7]: {
    assetCategoryId: 'ed1ad88e-403c-4e85-9a55-e46d9728ce64',
    assetCategoryCode: 'pwr-seven',
    assetCategoryName: 'Power 7',
    id: product.power7,
    translationKey: 'power7',
    image: '/members_web/products/power7/render-power7-list-v2.jpg',
    imageConfigure:
      '/members_web/products/power7/render-power7-configure-v3.png',
    imageBasket:
      '/members_web/products/power7/render-power7-configure-basket-v2.png',
    imageBasketMini:
      '/members_web/products/power7/render-power7-configure-basket-mini.png',
    imageRecommended: '/members_web/products/power7/recommend-power7.jpg',
    productCategory: productCategories.eBike,
    name: 'Power 7',
    uiName: `Power${NON_BR_SPACE}7`,
  },
  [product.originalPlus]: {
    assetCategoryId: '56be9e9c-2584-44de-8712-1a02e2117e89',
    assetCategoryCode: 'org-one-plus',
    assetCategoryName: 'Original 1+',
    id: product.originalPlus,
    translationKey: 'originalPlus',
    image:
      '/members_web/products/original-plus/render-original-plus-list-v2.jpg',
    imageConfigure:
      '/members_web/products/original-plus/render-original-plus-configure-v3.png',
    imageBasket:
      '/members_web/products/original-plus/render-original-plus-configure-basket-v2.png',
    imageBasketMini:
      '/members_web/products/original-plus/render-original-plus-configure-basket-mini.png',
    imageRecommended:
      '/members_web/products/original-plus/recommend-original-plus-1.jpg',
    productCategory: productCategories.city,
    name: 'Original',
    uiName: 'Original',
  },
  [product.original]: {
    assetCategoryId: '652c08a1-4482-4b98-99db-c4ff559604c2',
    assetCategoryCode: 'org',
    assetCategoryName: 'Original 1',
    id: product.original,
    translationKey: 'original',
    image: '/members_web/products/original/render-org-list-v2.png',
    imageConfigure:
      '/members_web/products/original/render-original-configure-v3.png',
    imageBasket:
      '/members_web/products/original/render-original-configure-basket-v2.png',
    imageBasketMini:
      '/members_web/products/original/render-original-configure-basket-mini.png',
    imageRecommended: '/members_web/products/original/recommend-original.jpg',
    productCategory: productCategories.city,
    name: 'Original',
    uiName: 'Original',
  },
  [product.deluxe7]: {
    assetCategoryId: 'eb390734-8742-4efd-94de-c8402714d489',
    assetCategoryCode: 'dlu',
    assetCategoryName: 'Deluxe 7',
    id: product.deluxe7,
    translationKey: 'deluxe7',
    image: '/members_web/products/deluxe7/render-deluxe7-list-v2.jpg',
    imageConfigure:
      '/members_web/products/deluxe7/render-deluxe7-configure-v3.png',
    imageBasket:
      '/members_web/products/deluxe7/render-deluxe7-configure-basket-v2.png',
    imageBasketMini:
      '/members_web/products/deluxe7/render-deluxe7-configure-basket-mini.png',
    imageRecommended: '/members_web/products/deluxe7/recommend-deluxe.jpg',
    productCategory: productCategories.city,
    name: 'Deluxe 7',
    uiName: `Deluxe${NON_BR_SPACE}7`,
  },
  [product.power1]: {
    assetCategoryId: '6b9fb517-9ff9-4c87-a258-d621211c664a',
    assetCategoryCode: 'pwr-one',
    assetCategoryName: 'Power 1',
    id: product.power1,
    translationKey: 'power1',
    image: '/members_web/products/power1/render-power1-list-v2.jpg',
    imageConfigure:
      '/members_web/products/power1/render-power1-configure-v3.png',
    imageBasket:
      '/members_web/products/power1/render-power1-configure-basket-v2.png',
    imageBasketMini:
      '/members_web/products/power1/render-power1-configure-basket-mini.png',
    imageRecommended: '/members_web/products/power1/recommend-power1.jpg',
    productCategory: productCategories.eBike,
    name: 'Power 1',
    uiName: `Power${NON_BR_SPACE}1`,
  },
  [product.powerPlus]: {
    assetCategoryId: 'ecbc5b33-e38d-4f13-b319-c08409af7924',
    assetCategoryCode: 'pwr-plus',
    assetCategoryName: 'Power Plus',
    id: product.powerPlus,
    translationKey: 'powerPlus',
    image: '/members_web/products/power-plus/power-plus-list.png',
    imageConfigure: '/members_web/products/power-plus/power-plus-configure.png',
    imageRecommended: '',
    productCategory: productCategories.eBike,
    name: 'Power Plus',
    uiName: `Power${NON_BR_SPACE}Plus`,
  },
};
